// extracted by mini-css-extract-plugin
export var externalLinkIcon = "_qr-5";
export var filledCircle = "_qr-4";
export var historyEntry = "_qr-3";
export var messageSideLeft = "_qr-1";
export var messageSideRight = "_qr-2";
export var orderTrackingCarouselWrapper = "_qr-6";
export var orderTrackingInfoContainer = "_qr-0";